import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postBonusesCreate = (params) => {
    return axios.post(`${backendHost}/api/admin/referrals/bonuses/create`, params);
};

export {
    postBonusesCreate
}